import { useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader, Typography } from '@altermaind/web/ui';
import { AlertBadge, GoToPublicsDocs } from '@/_shared/components';
import { getUserProfileCall } from '@/core/state';
import { getEmployeesStatsCall } from '@/people/state';
import { getSurveysCampaignsCall, useSurvey } from '@/surveys/state';
import { OverviewEmployees, OverviewSurveys, RecapPlatformBox } from '../components';

export const DashboardAdmin = () => {
  const t = useTranslations('dashboard.welcome');
  const tShared = useTranslations();

  const { firstName } = getUserProfileCall.hook();
  const {
    execute: executeGetEmployeesStats,
    loading: loadingGetEmployeesStats,
    error: errorGetEmployeesStats,
    success: successGetEmployeesStats,
    total,
    invalid,
    completed,
  } = getEmployeesStatsCall.hook();
  const {
    execute: executeGetSurveysCampaigns,
    loading: loadingGetSurveysCampaigns,
    error: errorGetSurveysCampaigns,
  } = getSurveysCampaignsCall.hook();

  const { organizationHasCampaignsHardSkill, organizationHasCampaignsSoftSkill } = useSurvey();

  useEffect(() => {
    executeGetEmployeesStats({});
    executeGetSurveysCampaigns({});
  }, [executeGetEmployeesStats, executeGetSurveysCampaigns]);

  if (loadingGetEmployeesStats || loadingGetSurveysCampaigns) {
    return (
      <Box mt='s' textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (errorGetEmployeesStats || errorGetSurveysCampaigns) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge containerProps={{ mt: 's' }} iconName='info' type='error' label={message} />;
  }

  if (successGetEmployeesStats && !loadingGetEmployeesStats && !errorGetEmployeesStats) {
    return (
      <Box>
        <Box display='flex' justifyContent='flex-end'>
          <GoToPublicsDocs mb='xxxxs' />
        </Box>
        <Box mb='s'>
          <Typography data-testid='dashboard-title' variant='h1' mb='xxs'>
            {t('title', { name: firstName })}
          </Typography>
          {organizationHasCampaignsSoftSkill && organizationHasCampaignsHardSkill ? (
            <Typography variant='p3/light'>{t('descriptionHasData')}</Typography>
          ) : (
            <Typography variant='p3/light'>{t('description')}</Typography>
          )}
        </Box>
        {!(
          organizationHasCampaignsSoftSkill &&
          organizationHasCampaignsHardSkill &&
          invalid === 0
        ) && <RecapPlatformBox />}
        {total > 0 && (
          <OverviewEmployees
            noTitle={!(organizationHasCampaignsSoftSkill && organizationHasCampaignsHardSkill)}
            total={total}
            completed={completed}
            invalid={invalid}
          />
        )}
        {(organizationHasCampaignsSoftSkill || organizationHasCampaignsHardSkill) && (
          <OverviewSurveys
            hasSoftAndHardSkillCampaigns={
              organizationHasCampaignsSoftSkill && organizationHasCampaignsHardSkill
            }
          />
        )}
      </Box>
    );
  }

  return null;
};
